import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { getPoetById, getFullPoemId } from '../../services/poetryService';
import {getWiki} from "../../types/poetry";

const PoemList: React.FC = () => {
  const { poetId } = useParams<{ poetId: string }>();

  if (!poetId) {
    return <Navigate to="/" replace />;
  }

  const result = getPoetById(poetId);

  if (!result) {
    return <Navigate to="/" replace />;
  }

  const { poet } = result;

  return (
    <div className="poem-list">
      <h1 className="poem-list__title">{poet.name}</h1>

      <ul className="poem-list__items">
        {getWiki(poet) && (
          <li>
            <Link to={`/bio/${poet.id}`} className="poem-list__item poem-list__bio-link">
              О песнику
            </Link>
          </li>
        )}
        {poet.poems.map(poem => (
          <li key={poem.id}>
            <Link to={`/poem/${getFullPoemId(poet.id, poem.id)}`} className="poem-list__item">
              {poem.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PoemList;

